import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";
import TRAText from "./TRAText";

export default function TRAContainer({ className, children, ...rest }) {
  return (
    <div className={cn(styles.container, className)} {...rest}>
      {children}
    </div>
  );
}

export function TRASection({ className, children, ...rest }) {
  return (
    <section className={cn(className)} style={{ marginBottom: "var(--tra-space-7, 24px)" }} {...rest}>
      {children}
    </section>
  );
}

export function TRAStack({ gap = 5, className, style, children, ...rest }) {
  return (
    <div
      className={cn(styles.stack, className)}
      style={{ gap: `var(--tra-space-${gap}, 16px)`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}

export function TRAFlex({ gap = 3, className, style, children, ...rest }) {
  return (
    <div
      className={cn(styles.flex, className)}
      style={{ gap: `var(--tra-space-${gap}, 8px)`, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
}

export function TRAGrid({ columns = 2, gap = 4, className, style, children, ...rest }) {
  return (
    <div
      className={cn(styles.grid, className)}
      style={{
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap: `var(--tra-space-${gap}, 12px)`,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export function TRADivider(props) {
  return <hr className={styles.divider} {...props} />;
}

export function TRASkeleton({ className, style, ...rest }) {
  return <div className={cn(styles.skeleton, className)} style={style} aria-hidden {...rest} />;
}

export function TRASpinner({ label = "Loading", ...rest }) {
  return (
    <div role="status" aria-label={label} {...rest}>
      <div className={styles.spinner} />
      <span className="tra-sr-only">{label}</span>
    </div>
  );
}

export function TRAEmptyState({ title, description, action }) {
  return (
    <div className={styles.empty}>
      {title ? (
        <TRAText as="h3" variant="title">
          {title}
        </TRAText>
      ) : null}
      {description ? <TRAText variant="body">{description}</TRAText> : null}
      {action}
    </div>
  );
}
